import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#E7257D',
                secondary: '#422A80',
                accent: '#682361',
                error: '#d82733',
                info: '#68C4CF',
                success: '#B1CF75',
                warning: '#e87e38'
            },
        },
    },
    icons: {
        iconfont: 'fa',
        values: {
            sort: 'fal fa-long-arrow-up ml-1',
            prev: 'fal fa-chevron-left',
            next: 'fal fa-chevron-right',
            dropdown: 'fal fa-chevron-down',
            expand: 'fal fa-chevron-down',
        },
    },
});
